var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ResultTable,{attrs:{"columns":_setup.columns,"data":_setup.tableData,"footer":_setup.footer}})
}
var staticRenderFns = []

export { render, staticRenderFns }